import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import LuckyDrawBg from 'assets/images/lucky-draw/lucky-draw-bg.png';
import LuckyDrawMobielBg from 'assets/images/lucky-draw/lucky-draw-mobiel-bg.png';
import { TYPE } from 'theme';
import { AutoColumn } from 'components/Column';
import HistoryDraw from './History';
import BasicInfo from './BasicInfo';
import LuckyDrawPool from './LuckyDrawPool';
import { isMobile } from 'react-device-detect';
import Bg from 'assets/images/lucky-draw/bg.png';
import { MainView } from 'pages/AppLoading';
import { useLocation } from 'react-router-dom';
import { useScrollToAnchor } from 'hooks/useScrollToAnchor';
import luckyDrawStore from 'stores/luckyDrawStore';
import user from 'stores/user';

const ResponsiveContainer = styled.div`
    padding: 0 100px;
    background-image: url(${Bg});
    background-size: contain;
    background-position: top center;
    background-repeat: no-repeat;
    padding-top: 100px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    overflow-x: hidden;

    @media (max-width: 768px) {
        padding: 0 20px;
        padding-top: 40px;
    }

    @media (max-width: 480px) {
        padding: 0 15px;
        padding-top: 30px;
    }
`;

const HeroSection = styled.div`
    position: relative;
    margin-top: 100px;
    overflow: hidden;

    @media (max-width: 768px) {
        margin-top: 60px;
    }

    @media (max-width: 480px) {
        margin-top: 40px;
    }
`;

const HeroImage = styled.img<{ $isMobile: boolean }>`
    height: 400px;
    width: 100%;
    object-fit: cover;
    object-position: ${({ $isMobile }) => ($isMobile ? 'top' : 'center')};
    display: block;

    @media (max-width: 768px) {
        height: 300px;
    }

    @media (max-width: 480px) {
        height: 250px;
    }
`;

const HeroContent = styled(AutoColumn)<{ $isMobile: boolean }>`
    position: absolute;
    top: ${({ $isMobile }) => ($isMobile ? '20%' : '50%')};
    left: 50%;
    width: 100%;
    transform: translate(-50%, -50%);
    gap: 4px;
    justify-content: center;

    @media (max-width: 480px) {
        top: 25%;
        padding: 0 20px;
    }
`;

function LuckyDraw() {
    const location = useLocation();
    useScrollToAnchor({ block: 'start', deps: [location.state, location.search] });

    useEffect(() => {
        if (user.address) {
            luckyDrawStore.fetchTodayStats(user.address);
        }
    }, []);

    return (
        <div>
            <HeroSection>
                <HeroImage src={isMobile ? LuckyDrawMobielBg : LuckyDrawBg} alt="" $isMobile={isMobile} />
                <HeroContent $isMobile={isMobile}>
                    <TYPE.desc fontSize={60} fontWeight={700} mobileFz={32}>
                        Daily Lucky Draw
                    </TYPE.desc>
                    <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', gap: '20px' }}>
                        <TYPE.desc fontSize={14} mobileFz={12}>
                            Lucky Draw Phase 1 will officially conclude on Dec 27, 10:00 UTC.
                        </TYPE.desc>
                        <div>
                            <TYPE.desc fontSize={14} mobileFz={12}>
                                Thank You for Participating in Lucky Draw Phase 1!
                            </TYPE.desc>
                            <TYPE.desc fontSize={14} mobileFz={12}>
                                Next phase opening soon. Follow us for updates!
                            </TYPE.desc>
                        </div>
                    </div>
                    {/* <p style={{ textAlign: 'center' }}>
                        <TYPE.desc fontSize={14} maxWidth={320} mobileFz={12}>
                            Finish daily tasks to participate in Lucky Draw More Points, More times to draw
                        </TYPE.desc>
                    </p> */}
                </HeroContent>
            </HeroSection>
            <MainView
                style={{
                    paddingTop: 0,
                    paddingBottom: isMobile ? '20px' : '40px',
                }}
            >
                <ResponsiveContainer>
                    <AutoColumn gap="40px" style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
                        <BasicInfo />
                        <LuckyDrawPool />
                        <HistoryDraw />
                    </AutoColumn>
                </ResponsiveContainer>
            </MainView>
        </div>
    );
}

export default observer(LuckyDraw);
